import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class IntKeyValue {
  @IsNumber()
  @Expose()
  key!: number;
  @IsString()
  @Expose()
  value!: string;
}
